import { LocationVarKey } from "@swivl-mono/types";

import { WorksheetColumn, WorksheetLayout, WorksheetRow } from "../../../Components/Worksheets/Layout/Worksheet.Layout.Components";
import { IS_NOT_EQUAL } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import { WorksheetComponent, WorksheetComponentType } from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponent.Component";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export default function LocationSubpageInformation() {
  const page = usePropertiesGetLocationIds();

  return (
    <WorksheetLayout>
      <h4>Storage Amenities</h4>
      <WorksheetRow>
        <WorksheetColumn>
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="24 Hour Access"
            keyName={LocationVarKey.Has24HourAccess}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="After Hours Access"
            keyName={LocationVarKey.HasAfterHoursAccess}
          />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Appointments" keyName={LocationVarKey.HasAppointments} />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Climate Controlled Units"
            keyName={LocationVarKey.HasClimateControlledUnits}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Conference Room"
            keyName={LocationVarKey.HasConferenceRoomnceRoom}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Deliveries Accepted"
            keyName={LocationVarKey.HasDeliveriesAccepted}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Drive-Up Units"
            keyName={LocationVarKey.HasDriveUpUnits}
          />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Dollies" keyName={LocationVarKey.HasDollies} />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Dumpster" keyName={LocationVarKey.HasDumpsters} />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Electricity In Unit"
            keyName={LocationVarKey.HasElectricityInUnit}
          />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Elevators" keyName={LocationVarKey.HasElevators} />
        </WorksheetColumn>

        <WorksheetColumn>
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Heated Units"
            keyName={LocationVarKey.HasHeatedUnitsts}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.MULTI_LINE}
            {...page}
            label="Loading Area Type"
            keyName={LocationVarKey.LoadingAreaType}
          />
          <WorksheetComponent componentType={WorksheetComponentType.MULTI_LINE} {...page} label="Lock Type" keyName={LocationVarKey.LockTypes} />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Moving Truck" keyName={LocationVarKey.HasMovingTrucks} />
          <WorksheetComponent
            componentType={WorksheetComponentType.MULTI_LINE}
            {...page}
            label="Moving Truck Type"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasMovingTrucks, "1")}
            keyName={LocationVarKey.TruckTypes}
          />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Notary" keyName={LocationVarKey.HasNotary} />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Office Space" keyName={LocationVarKey.HasOfficeSpace} />
          <WorksheetComponent
            componentType={WorksheetComponentType.MULTI_LINE}
            {...page}
            label="On Location Parking Type"
            keyName={LocationVarKey.ParkingType}
          />

          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Padlock Codes" keyName={LocationVarKey.HasPadlocks} />
          <WorksheetComponent
            componentType={WorksheetComponentType.MULTI_LINE}
            {...page}
            label="Payment Options"
            keyName={LocationVarKey.PaymentOptions}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.MULTI_LINE}
            {...page}
            label="Security Amenities"
            keyName={LocationVarKey.SecurityAmenities}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Video Surveillance"
            keyName={LocationVarKey.HasVideoSurveillanceveillance}
          />
        </WorksheetColumn>
      </WorksheetRow>
    </WorksheetLayout>
  );
}
